import React from "react"
import styles from "./styles"
import {
  FormControl,
  InputLabel,
  Typography,
  Input,
  FormHelperText
} from "@material-ui/core/"
import { withStyles } from "@material-ui/core/styles"
import { connect } from "react-redux"
import { compose } from "recompose"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import _ from "lodash"

const ReusableFormControl = ({
  classes,
  name,
  label,
  openFrom,
  formikProps,
  inputProps = {},
  inputLabelClass = "",
  inputClass = "",
  isSettings = false
}) => {
  const {
    handleChange,
    handleBlur,
    touched,
    errors,
    values,
    handleSubmit,
    status
  } = formikProps

  let statusError
  if (_.isEmpty(status) !== true) {
    statusError = status[name]
  }

  return (
    <FormControl
      error={(errors[name] && touched[name]) || Boolean(statusError)}
      className={inputClass}
    >
      <InputLabel htmlFor={name}>
        <Typography variant="h5" className={inputLabelClass}>
          {label}
        </Typography>
      </InputLabel>
      <Input
        type="text"
        name={name}
        id={name}
        value={values[name] ? values[name] : ""}
        onChange={handleChange}
        onBlur={e => {
          handleBlur(e)

          // Passed from setting page inputs. If true will submit form
          if (
            isSettings &&
            formikProps.initialValues[e.target.name] !==
              formikProps.values[e.target.name]
          ) {
            handleSubmit()
          }
        }}
        {...inputProps}
      />
      <FormHelperText className={classes.errorContainer}>
        {(touched[name] && errors[name]) || statusError}
      </FormHelperText>
    </FormControl>
  )
}

const mapStateToProps = state => {
  return {
    openFrom: state.updateUserDialog.openFrom
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  withMobileDialog()
)(ReusableFormControl)



// WEBPACK FOOTER //
// ./src/components/ReusableFormControl/index.jsx